import { createTheme } from "@mui/material";

import palette from './palette.module.scss';
import { baseTheme } from './base-theme';

export const lightTheme = createTheme({
  ...baseTheme,
  palette: {
    mode: 'light',
    primary: {
      main: palette.colorPrimary,
      contrastText: '#fff'
    },
    secondary: {
      main: palette.colorSecondary,
      contrastText: '#fff'
    },
    tertiary: {
      main: palette.colorTertiary
    },
    text: {
      primary: palette.colorText,
      disabled: palette.colorTextDisabled
    },
    error: {
      main: palette.colorError
    },
    success: {
      main: palette.colorSuccess
    },
    warning: {
      main: palette.colorWarning
    },
    light: {
      main: palette.colorLight
    },
    lightGrey: {
      main: palette.colorLightGrey
    }
  },
  components: {
    ...baseTheme.components,
    MuiCssBaseline: {
      styleOverrides: {
        ':root': {
          '--color-primary': palette.colorPrimary,
          '--color-primary-rgb': palette.colorPrimaryRGB,
          '--color-text': palette.colorText,
          '--color-text-rgb': palette.colorTextRGB,
          '--color-text-disabled': palette.colorTextDisabled,
          '--color-text-disabled-rgb': palette.colorTextDisabledRGB,
          '--color-secondary': palette.colorSecondary,
          '--color-secondary-rgb': palette.colorSecondaryRGB,
          '--color-tertiary': palette.colorTertiary,
          '--color-tertiary-rgb': palette.colorTertiaryRGB,
          '--color-error': palette.colorError,
          '--color-error-rgb': palette.colorErrorRGB,
          '--color-success': palette.colorSuccess,
          '--color-success-rgb': palette.colorSuccessRGB,
          '--color-warning': palette.colorWarning,
          '--color-warning-rgb': palette.colorWarningRGB,
          '--color-light': palette.colorLight,
          '--color-light-rgb': palette.colorLightRGB,
          '--color-lightGrey': palette.colorLightGrey,
          '--color-lightGrey-rgb': palette.colorLightGreyRGB,
          '--color-bodyBackground': palette.colorBodyBackground,
          '--color-bodyBackground-rgb': palette.colorBodyBackgroundRGB,
          '--box-shadow': `0px 5px 5px -3px rgb(0 0 0 / 10%), 0px 8px 10px 1px rgb(0 0 0 / 6%), 0px 3px 14px 2px rgb(0 0 0 / 4%)`,
          '--border-card': 'none'
        },
        'input:-webkit-autofill': {
          boxShadow: `0 0 0 30px white inset !important`
        },
        'input:-webkit-autofill:hover': {
          boxShadow: `0 0 0 30px white inset !important`
        },
        'input:-webkit-autofill:focus': {
          boxShadow: `0 0 0 30px white inset !important`
        },
        'input:-webkit-autofill:active': {
          boxShadow: `0 0 0 30px white inset !important`
        }
      }
    },
    MuiPaper: {
      ...baseTheme.components.MuiPaper,
      styleOverrides: {
        ...baseTheme.components.MuiPaper?.styleOverrides,
        root: {
          ...(baseTheme.components.MuiPaper?.styleOverrides?.root as any),
          boxShadow: `var(--box-shadow)`
        }
      }
    }
  }
});